<template>
    <b-button class="btn-table" :id="`edit-btn-${id}`" @click="$emit('click')" v-b-tooltip="titleTooltip">
        <DynamicIcon icon="table-edit" classString="icon-btn-table"/>
        <!-- <b-tooltip :target="`edit-btn-${id}`" :title=""/> -->
    </b-button>
</template>

<script>
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";

export default {
    components: {
       DynamicIcon
    },
    props: {
        id: Number,
        titleTooltip: String
    }
}
</script>


<style scoped lang="scss">
</style>
